import React, {useEffect} from 'react';
import {Box, FormControl, FormGroup, RadioGroup, Radio, Checkbox} from "@mui/material";
import clsx from "clsx";
import _ from "lodash";
import {
  StyledContainer,
  StyledQuizTitle,
  StyledAnswer,
  StyledAnswerButton,
  StyledQuestionTitle,
  StyledButton
} from "./styles";

function Quiz(props) {
  const {quizList, changeAnswer, answered, showAnswer, setAutoShowAns, disabled} = props;

  useEffect(() => {
    if (quizList?.length) {
      let autoShowAns = false
      const typeArray = _.flatMap(quizList, (quiz) => {
        return _.flatMap(quiz.questions, (qs) => qs.type);
      });
      const typeSet = _.uniq(typeArray);

      if (typeSet.length === 1 && typeSet.includes('button')) {
        autoShowAns = true;
      }
      setAutoShowAns(autoShowAns);
    }
  }, [quizList])

  if (!quizList?.length) {
    return null;
  }

  const handleChange = (e, qid) => {
    const {value, checked, type} = e.target;
    changeAnswer(value, checked, type, qid);
  }

  return (
    <StyledContainer>
      {quizList.map(quiz => (
        <Box key={quiz.id}>
          <StyledQuizTitle component="h4" m={0} my={1}>{quiz.title}</StyledQuizTitle>
          <Box component="small">{quiz.text}</Box>
          {quiz.questions && quiz.questions.map(question => {
            const questionAnswered = answered[question.id] || [];
            const correctAnswers = quiz.answers[question.id] || [];
            const corrected = correctAnswers.every(a => questionAnswered.includes(a)) && correctAnswers.length === questionAnswered.length;

            let Group = FormGroup;
            let Control = Checkbox;
            if (question.type === 'radio') {
              Group = RadioGroup;
              Control = Radio;
            } else if (question.type === 'checkbox') {
              Group = FormGroup;
              Control = Checkbox;
            }

            let formContent = (
              <FormControl disabled={disabled} fullWidth>
                <Group onChange={(e) => handleChange(e, question.id)}>
                  {question.choices.map(choice => {
                    const checked = questionAnswered.includes(choice.value);
                    const checkedText = choice.checked || "OK";

                    let labelAnswer = <span><em>{choice.title || ''}</em> {choice.text}</span>;
                    if (question.type === 'button') {
                      labelAnswer = (
                        <StyledButton
                          variant="contained" color="primary"
                          disabled={checked} disableElevation
                          onClick={() => changeAnswer(choice.value, true, question.type, question.id)}
                        >
                          {!checked ? choice.text : checkedText}
                        </StyledButton>
                      );
                    }

                    const StyledFormControlLabel = question.type === 'button' ? StyledAnswerButton : StyledAnswer;

                    return (
                      <StyledFormControlLabel
                        key={choice.value}
                        value={choice.value}
                        control={<Control color="primary" checked={checked} style={{display: question.type === 'button' ? 'none' : 'block'}} />}
                        label={labelAnswer}
                        className={clsx({
                          checked: checked,
                          correctAnswer: showAnswer && corrected && correctAnswers.includes(choice.value),
                        })}
                      />
                    )
                  })}
                </Group>
              </FormControl>
            );

            return (
              <Box key={question.id} my={1}>
                <StyledQuestionTitle component="h5" m={0} my={1}
                     className={clsx({
                       wrong: showAnswer && !corrected,
                       correct: showAnswer && corrected,
                     })}
                >
                  {question.title}
                </StyledQuestionTitle>
                <Box component="small">{question.text}</Box>
                <Box mt={1} mb={2}>
                  {formContent}
                </Box>
              </Box>
            )
          })}
        </Box>
      ))}
    </StyledContainer>
  )
}

export default Quiz;